import { StyledItemSelect } from "@iventis/components";
import { Theme } from "@emotion/react";
import { Content } from "@iventis/translations/content/typed-content";
import { userLocalStorageItems, userLocalStorageManager } from "@iventis/local-storage/src/user-local-storage";
import { MenuItem, Select, useTheme } from "@mui/material";
import React, { FunctionComponent } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useIventisTranslate } from "@iventis/translations/use-iventis-translate";
import { UnitOfMeasurement } from "@iventis/domain-model/model/unitOfMeasurement";
import { MapGlobalState } from "@iventis/map-engine/src/state/map.state.types";
import { AuthState } from "@iventis/permissions/src/auth.slice";
import { map } from "@iventis/plans/src/state/map.slice";

interface UnitSelectorProps {
    className?: string;
}

export const UnitSelector: FunctionComponent<UnitSelectorProps> = ({ className }) => {
    const dispatch = useDispatch();
    const { unitOfMeasurement, userId } = useSelector((s: { mapReducer: MapGlobalState; auth: AuthState }) => ({
        unitOfMeasurement: s.mapReducer.mapModule.unitOfMeasurement.value,
        userId: s.auth.user.userId,
    }));
    const translate = useIventisTranslate();
    const theme = useTheme<Theme>();

    const handleUnitOfMeasurementChange = (unit: UnitOfMeasurement) => {
        dispatch(map.actions.setUnitOfMeasurement(unit));
        userLocalStorageManager.set(userLocalStorageItems.mapUnitOfMeasurement, userId, unit);
    };

    return (
        <div className={className}>
            <span>{translate(Content.map.measurements.unit_of_measurement)}</span>
            <Select
                value={unitOfMeasurement}
                onChange={(event) => handleUnitOfMeasurementChange(event.target.value as UnitOfMeasurement)}
                input={<StyledItemSelect $verticalPadding="4px" $borderColour={theme.shades.three} />}
            >
                <MenuItem value={UnitOfMeasurement.Metric}>{translate(Content.map.measurements.metric)}</MenuItem>
                <MenuItem value={UnitOfMeasurement.Imperial}>{translate(Content.map.measurements.imperial)}</MenuItem>
            </Select>
        </div>
    );
};
